import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TimeRecordingComponent } from '@pages/time-recording/time-recording.component';
import { HomeComponent } from '@pages/home/home.component';
//import { LoginComponent } from '@pages/login/login.component';
import { GestionEmpleadosComponent } from '@pages/admin/empleados/gestion-empleados/gestion-empleados.component';
import { ProyectosComponent } from '@pages/admin/proyectos/gestion-proyectos/proyectos.component';
import { ReconocimientoProyectosComponent } from '@pages/admin/proyectos/reconocimiento-proyectos/reconocimiento-proyectos.component';
import { GestionCliComponent } from '@pages/admin/clientes/gestion-cliente/gestion-cli.component';
import { GestionCalendariosComponent } from '@app/pages/admin/calendarios/gestion-calendario/gestion-calendarios.component';
import { ServerComponent } from '@pages/error/server/server.component';
import { InternalComponent } from '@pages/error/internal/internal.component';
import { CalendariosBloqueoComponent } from '@pages/admin/calendarios/calendarios-bloqueo/calendarios-bloqueo.component';
import { ExportacionComponent } from '@pages/admin/exportacion/exportacion.component';
import { GestionEmpleadosImputacionComponent } from '@pages/admin/empleados/gestion-empleados-imputacion/gestion-empleados-imputacion.component';
import { DistribuidoraComponent } from '@pages/admin/distribuidora/distribuidora.component';
import { AuthService } from './services/auth/auth.service';
import { MasterGuard } from './services/guard/master.guard';
import { AdminAuthGuard } from './services/guard/admin-auth/admin-auth.guard';
import { GUARDS } from '@app/constants/guards';
import { APP_URLS } from './constants/app-urls';
import { LoginManualComponent } from './pages/login-manual/login-manual.component';

const routes: Routes = [
  // Pages
  {
    path: '',
    redirectTo: '/' + APP_URLS.loginPath,
    pathMatch: 'full',
  },
  /* Reemplaza el antiguo LoginComponent por LoginManualComponent */
  {
    path: APP_URLS.loginPath,
    component: LoginManualComponent,
    data: { title: 'TITLE.LOGIN' }
  },
  {
    path: APP_URLS.homePath,
    component: HomeComponent,
    // canActivate: [AuthService],
    data: {
      title: 'TITLE.HOME',
      parent: APP_URLS.homePath
    },
  },
  {
    path: APP_URLS.imputationPath,
    component: TimeRecordingComponent,
    // canActivate: [AuthService],
    data: {
      title: 'TITLE.IMPUTACINES',
      parent: APP_URLS.imputationPath
    },
  },
  // CALENDARIOS
  {
    path: APP_URLS.calendarManagementPath,
    component: GestionCalendariosComponent,
    canActivate: [MasterGuard],
    data: {
      title: 'TITLE.GESTION_CALENDARIOS',
      guards: [
        GUARDS.AdminGuard,
        GUARDS.DirectionGuard
      ],
      parent: APP_URLS.distributorPath
    },
  },
  {
    path: APP_URLS.calendarLockPath,
    component: CalendariosBloqueoComponent,
    canActivate: [MasterGuard],
    data: {
      title: 'TITLE.BLOQUEO_CALENDARIOS',
      guards: [
        GUARDS.AdminGuard,
        GUARDS.DirectionGuard
      ],
      parent: APP_URLS.distributorPath
    },
  },
  // EXPORTACION
  {
    path: APP_URLS.exportPath,
    component: ExportacionComponent,
    canActivate: [MasterGuard],
    data: {
      title: 'TITLE.EXPORTACION',
      guards: [
        GUARDS.AdminGuard,
        GUARDS.DirectionGuard,
        GUARDS.OperationsGuard,
        GUARDS.ManagerGuard
      ],
      parent: APP_URLS.distributorPath
    }
  },
  {
    path: APP_URLS.distributorPath,
    component: DistribuidoraComponent,
    canActivate: [MasterGuard],
    data: {
      title: 'TITLE.DISTRIBUIDORA',
      guards: [
        GUARDS.AdminGuard,
        GUARDS.DirectionGuard,
        GUARDS.OperationsGuard,
        GUARDS.ManagerGuard
      ],
      parent: APP_URLS.distributorPath
    },
  },
  // EMPLEADOS
  {
    path: APP_URLS.employeeManagementPath,
    component: GestionEmpleadosComponent,
    canActivate: [MasterGuard],
    data: {
      title: 'TITLE.GESTION_EMPLEADOS',
      guards: [
        GUARDS.AdminGuard,
        GUARDS.DirectionGuard,
        GUARDS.OperationsGuard
      ],
      parent: APP_URLS.distributorPath
    },
  },
  {
    path: APP_URLS.employeeImputationManagementPath,
    component: GestionEmpleadosImputacionComponent,
    canActivate: [MasterGuard],
    data: {
      title: 'TITLE.GESTION_IMPUTACION_EMPLEADO',
      guards: [
        GUARDS.AdminGuard,
        GUARDS.DirectionGuard,
        GUARDS.OperationsGuard
      ],
      parent: APP_URLS.distributorPath
    },
  },
  // PROYECTOS
  {
    path: APP_URLS.projectManagementPath,
    component: ProyectosComponent,
    canActivate: [MasterGuard],
    data: {
      title: 'TITLE.GESTION_PROYECTOS',
      guards: [
        GUARDS.AdminGuard,
        GUARDS.DirectionGuard
      ],
      parent: APP_URLS.distributorPath
    },
  },
  {
    path: APP_URLS.projectRecognitionPath,
    component: ReconocimientoProyectosComponent,
    canActivate: [MasterGuard],
    data: {
      title: 'TITLE.PROJECT_RECOGNITION',
      guards: [
        GUARDS.AdminGuard,
        GUARDS.DirectionGuard
      ],
      parent: APP_URLS.distributorPath
    },
  },
  // CLIENTES
  {
    path: APP_URLS.customerManagementPath,
    component: GestionCliComponent,
    canActivate: [AuthService],
    data: {
      title: 'TITLE.GETION_CLIENTES',
      parent: APP_URLS.distributorPath
    },
  },
  // ERROR
  {
    path: APP_URLS.errorServerPath,
    component: ServerComponent,
    canActivate: [AuthService],
    data: { title: 'TITLE.ERROR_SERVER' },
  },
  {
    path: APP_URLS.errorInternalPath,
    component: InternalComponent,
    canActivate: [AuthService],
    data: { title: 'TITLE.EROR_INTERNAL' },
  },
  {
    path: '**',
    component: InternalComponent,
    canActivate: [AuthService],
    data: { title: 'TITLE.EROR_INTERNAL' },
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: false }),
  ],
  declarations: [],
  exports: [RouterModule]
})

export class AppRoutingModule { }
